export const TOKEN_VERSION = 2;
export var TOKEN_TYPE;
(function (TOKEN_TYPE) {
    TOKEN_TYPE["ACCESS"] = "access";
    TOKEN_TYPE["REFRESH"] = "refresh";
})(TOKEN_TYPE || (TOKEN_TYPE = {}));
export const TOKEN_EXPIRY = {
    ACCESS: '1d',
    REFRESH: '1y',
};
export const ADMIN_TOKEN_EXPIRY = {
    ACCESS: '1h',
    REFRESH: '7d',
};
//# sourceMappingURL=jwt.consts.js.map